export const PLANT_STATUS = {
  AVAILABLE: 'Disponível',
  RESERVED: 'Reservado',
  IN_PROPOSAL: 'Em Proposta',
  SOLD: 'Vendido',
};
